import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { MapserviceService } from './services/map-services.service';
import { UtilitiesService } from './services/utilities-services.service';
import { TablesService } from './services/tables-services.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'lake-floodplain';

  constructor(public dialog: MatDialog) {}
}

/*                   ***                     */
/* Modal dialogs (see modal-windows folder) */
/*                   ***                   */

// About Modal Dialog (see: about-dialog.html)
@Component({
  selector: 'app-about-dialog',
  templateUrl: './about-dialog.html',
})
export class AboutDialogComponent {}

// About Splash Modal Dialog (see: about-splash-dialog.html)
@Component({
  selector: 'app-about-splash-dialog',
  templateUrl: './about-splash-dialog.html',
})
export class AboutSplashDialogComponent {}

// About Login Modal Dialog (see: about-login-dialog.html)
@Component({
  selector: 'app-about-login-dialog',
  templateUrl: './about-login-dialog.html',
})
export class AboutLoginDialogComponent {}

// Action Complete Modal Dialog (see: action-complete.html)
@Component({
  selector: 'app-action-complete',
  templateUrl: './action-complete.html',
})
export class AboutActionCompleteComponent implements OnInit {
  // Items to display in the modal
  submittedRecord;
  actionType;

  constructor(
    private mapService: MapserviceService,
    private utilitiesService: UtilitiesService
  ) {}

  ngOnInit() {
    /* Submitted record subscription */
    this.utilitiesService.submittedRecord.subscribe((result) => {
      this.submittedRecord = result;
    });
    /* Action type subscription */
    this.utilitiesService.actionType.subscribe((result) => {
      this.actionType = result;
    });
  }
}

// About Delete Modal Dialog (see: about-delete.html)
@Component({
  selector: 'app-about-delete',
  templateUrl: './about-delete.html',
})
export class AboutDeleteComponent {}

// About Delete Study Modal Dialog (see: about-delete-study.html)
@Component({
  selector: 'app-about-study-delete',
  templateUrl: './about-delete-study.html',
})
export class AboutStudyDeleteComponent implements OnInit {
  // Feature table
  studiesFeatureTable;

  // Pre-populate record
  userSelectedRecords = [];

  // Form fields
  objectToDelete;
  studyName: string;
  studyRemarks: string;

  constructor(
    private mapService: MapserviceService,
    private utilitiesService: UtilitiesService,
    private tablesService: TablesService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    /* Selected record subscription */
    this.tablesService.userSelectedRecords.subscribe((result) => {
      this.userSelectedRecords = result;
      this.updateFormFields();
    });
    /* Studies feature table subscription */
    this.mapService.studiesFeatureTable.subscribe((result) => {
      this.studiesFeatureTable = result;
    });
  }

  // Update the form fields
  updateFormFields() {
    this.objectToDelete = this.userSelectedRecords[0].attributes.objectid;
    this.studyName = this.userSelectedRecords[0].attributes.study_name;
    this.studyRemarks = this.userSelectedRecords[0].attributes.study_remark;
  }

  // Delete the record
  deleteStudy() {
    this.mapService.deleteStudy(this.objectToDelete).then(
      (result) => {
        // Send study name and status to mapService
        this.utilitiesService.updateRecordSubmission(this.studyName, 'removed');
        // Open the success dialog (deleted record)
        this.dialog.open(AboutActionCompleteComponent, {
          maxWidth: '100vw',
          width: '1000px',
          maxHeight: '90vh',
        });
        // Refresh the studies feature table
        this.studiesFeatureTable.refresh();
      },
      (error) => {
        // throw error;   // Can also throw the error to a global error handler
      }
    );
  }
}

// About Delete Elevation Modal Dialog (see: about-delete-elevation.html)
@Component({
  selector: 'app-about-elevation-delete',
  templateUrl: './about-delete-elevation.html',
})
export class AboutElevationDeleteComponent implements OnInit {
  // Feature table
  elevationsFeatureTable;

  // Pre-populate the record
  elevationsSelected = [];

  // Form fields
  objectToDelete = [];
  lakeBasinID = [];

  constructor(
    private mapService: MapserviceService,
    private utilitiesService: UtilitiesService,
    private tablesService: TablesService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    /* Elevations selected records subscription */
    this.tablesService.elevationsSelected.subscribe((result) => {
      this.elevationsSelected = result;
      this.updateFormFields();
    });

    /* Elevations feature table subscription */
    this.mapService.elevationsFeatureTable.subscribe((result) => {
      this.elevationsFeatureTable = result;
    });
  }

  // Add content to form for verification
  updateFormFields() {
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < this.elevationsSelected.length; i++) {
      this.objectToDelete.push(this.elevationsSelected[i].attributes.objectid);
      this.lakeBasinID.push(this.elevationsSelected[i].attributes.dowlknum);
    }
  }

  // Delete elevation from table
  deleteElevation() {
    this.mapService.deleteElevations(this.objectToDelete).then(
      (result) => {
        // Send basin ID and status to mapService
        this.utilitiesService.updateRecordSubmission(
          this.lakeBasinID,
          'removed'
        );
        // Open the success dialog (deleted record)
        this.dialog.open(AboutActionCompleteComponent, {
          maxWidth: '100vw',
          width: '1000px',
          maxHeight: '90vh',
        });
        // Refresh the elevations feature table
        this.elevationsFeatureTable.refresh();
      },
      (error) => {
        // throw error;   // Can also throw the error to a global error handler
      }
    );
  }
}

// Add Study Table Dialog (see: add-study.html)
@Component({
  selector: 'app-study',
  templateUrl: './add-study.html',
})
export class AddStudyComponent implements OnInit {
  // Studies Feature Table
  studiesFeatureTable;

  // Form submission validation
  formSubmission = false;

  // Form fields
  studyName: string;
  studyRemarks: string;
  studyDate;
  fsID: string;
  verticalDatum: string;
  sourceType: string;

  constructor(
    private mapService: MapserviceService,
    private utilitiesService: UtilitiesService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    /* Studies feature table subscription */
    this.mapService.studiesFeatureTable.subscribe((result) => {
      this.studiesFeatureTable = result;
    });
  }

  // Verify fields and their requirements before the user can submit the record
  verifyFormSubmission() {
    if (
      this.studyName &&
      this.studyName.length < 50 &&
      this.studyDate &&
      this.verticalDatum
    ) {
      this.formSubmission = true;
    } else {
      this.formSubmission = false;
    }
  }

  /* *** Add a new study *** */
  // 1. Get the highest fs_id value and add +1
  // 2. Send the form data to the service to post
  // See: mapservice.service.ts
  addStudy() {
    // 1. Get the highest fs_id value and add +1
    this.mapService.updateID().subscribe((result) => {
      debugger;
      // tslint:disable-next-line: no-string-literal
      this.fsID = result['features'][0].attributes.max_id + 1;
      // 2. Send the form data to the service to post
      this.mapService
        .postStudy(
          this.studyName,
          this.studyRemarks,
          this.studyDate,
          this.fsID,
          this.verticalDatum,
          this.sourceType
        )
        .then(
          (results) => {
            debugger;
            // Send study name and status to mapService
            this.utilitiesService.updateRecordSubmission(
              this.studyName,
              'added'
            );
            // Open the success dialog (added record)
            this.dialog.open(AboutActionCompleteComponent, {
              maxWidth: '100vw',
              width: '1000px',
              maxHeight: '90vh',
            });
            // Refresh the studies feature table
            this.studiesFeatureTable.refresh();
          },
          (error) => {
            debugger;
            // throw error;   // Can also throw the error to a global error handler
          }
        );
    });
  }
}

// Add Elevations Table Dialog (see: add-elevation.html)
@Component({
  selector: 'app-elevation',
  templateUrl: './add-elevation.html',
})
export class AddElevationComponent implements OnInit {
  // Elevation feature table
  elevationsFeatureTable;

  // Form submission validation
  formSubmissionElevations = false;
  elevationSelected = false;
  lakeBasinValid = true;

  // Pre-populated fields
  selectedStudyName: string;
  userSelectedID: number;
  userSelectedObjectID: number;
  lakeBasinName: string;

  // Form fields
  lakeBasinID: string;
  tenYearElevation: number;
  tenYearElevationComments: string;
  twentyFiveYearElevation: number;
  twentyFiveYearElevationComments: string;
  fiftyYearElevation: number;
  fiftyYearElevationComments: string;
  oneHundredYearElevation: number;
  oneHundredYearElevationComments: string;
  fiveHundredYearElevation: number;
  fiveHundredYearElevationComments: string;

  constructor(
    private mapService: MapserviceService,
    private utilitiesService: UtilitiesService,
    private tablesService: TablesService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    /* User selection ID subscription */
    this.tablesService.userSelectedID.subscribe((result) => {
      this.userSelectedID = result;
    });
    /* Selected study name subscription */
    this.tablesService.selectedStudyName.subscribe((result) => {
      this.selectedStudyName = result;
    });
    /* User selected object ID subscription */
    this.tablesService.userSelectedObjectID.subscribe((result) => {
      this.userSelectedObjectID = result;
    });
    /* Elevations feature table subscription */
    this.mapService.elevationsFeatureTable.subscribe((result) => {
      this.elevationsFeatureTable = result;
    });
  }

  /* Query to get the lake name in the add elevation modal dialog */
  queryLakeName(id: string) {
    this.mapService.queryLakeName(id).subscribe(
      (response) => {
        // tslint:disable-next-line: no-string-literal

        if (response['features'][0]) {
          // tslint:disable-next-line: no-string-literal
          this.lakeBasinName = response['features'][0].attributes.pw_basin_name;
          this.lakeBasinValid = true;
        } else {
          this.lakeBasinName = '';
          if (id.length === 8) {
            this.lakeBasinValid = false;
          }
        }
      },
      (error) => {
        // throw error;   // Can also throw the error to a global error handler
      }
    );
  }

  // Verify elevation number is present
  //  Note: At least one elevation MUST be entered to submit the form
  verifyElevation() {
    if (
      this.tenYearElevation ||
      this.twentyFiveYearElevation ||
      this.fiftyYearElevation ||
      this.oneHundredYearElevation ||
      this.fiveHundredYearElevation
    ) {
      this.elevationSelected = true;
    } else {
      this.elevationSelected = false;
    }
  }

  // Verify fields and their requirements before the user can submit the record
  verifyFormSubmission() {
    if (this.lakeBasinID && this.elevationSelected) {
      this.formSubmissionElevations = true;
    } else {
      this.formSubmissionElevations = false;
    }
  }

  /* *** Add a new elevation *** */
  // See: mapservice.service.ts
  addElevation() {
    this.mapService
      .postElevation(
        this.lakeBasinID,
        this.lakeBasinName,
        this.userSelectedID,
        this.tenYearElevation,
        this.tenYearElevationComments,
        this.twentyFiveYearElevation,
        this.twentyFiveYearElevationComments,
        this.fiftyYearElevation,
        this.fiftyYearElevationComments,
        this.oneHundredYearElevation,
        this.oneHundredYearElevationComments,
        this.fiveHundredYearElevation,
        this.fiveHundredYearElevationComments
      )
      .then(
        (result) => {
          // Send basin name and status to mapService
          this.utilitiesService.updateRecordSubmission(
            this.lakeBasinName,
            'added'
          );
          // Open the success dialog (added record)
          this.dialog.open(AboutActionCompleteComponent, {
            maxWidth: '100vw',
            width: '1000px',
            maxHeight: '90vh',
          });
          // Refresh the elevations feature table
          this.elevationsFeatureTable.refresh();
        },
        (error) => {
          // throw error;   // Can also throw the error to a global error handler
        }
      );
  }
}
